import { Routes, Route } from "react-router-dom";
import AppShell from "@/components/AppShell";
import BuyerMarketplace from "@/pages/buyer/Marketplace";
import BuyerRFQ from "@/pages/buyer/RFQ";
import BuyerOrders from "@/pages/buyer/Orders";
import AuditLog from "@/pages/settings/AuditLog";
import MfaSettings from "@/pages/settings/Mfa";

export default function BuyerDashboard() {
  return (
    <AppShell variant="buyer">
      <Routes>
        <Route path="/" element={<BuyerMarketplace />} />
        <Route path="/rfq" element={<BuyerRFQ />} />
        <Route path="/orders" element={<BuyerOrders />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
